import React, {useState} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";


export default ({ContasTel, ContasNome, ListEsp, IdConta, DadCont, UsuariosContServ, setUsuariosContServ, Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, }) => {
const [NomeEdit, setNomeEdit] = useState(ListEsp.Nome);
const [Titulo, setTitulo] = useState("Vizualizar Categoria");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [IdContRes, setIdContRes] = useState(ListEsp.IdConta);
 const [Progress, setProgress] = useState(10);

        const Editando = ()=>{
          if(NomeEdit !=="" && NomeEdit !==" " && NomeEdit !=="  " && NomeEdit !=="   " && NomeEdit !=="    " && NomeEdit !=="     " && NomeEdit !=="      "
          && NomeEdit !=="       " && NomeEdit !=="        " && NomeEdit !=="         " && NomeEdit !=="          " 
          && NomeEdit !=="           " ){
            if (navigator.onLine) {
                setLoading(true)
                Api.TAEditandoCategoria(IdContRes, Dados, Id, NomeEdit, UsuariosContServ, setUsuariosContServ, setAlert, setAlertTipo, setLoading, setMsgErro, setProgress);
         
               
              } else {
                setAlert("Sem Internet");
                setAlertTipo("danger");
              }
            }else {
                  setMsgErro("Preencha o Nome da Categoria")
              }
        }
  
 
  

        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                      {/* <div className="callout callout-info">
            <h5><i className="fas fa-info" /> Nota:</h5>
           Você só poderá editar a Categoria, mas jamais excluir pois essa Categoria ja foi usada em  outras Exercicio!
            </div> */}
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                      <i className="fas fa-bezier-curve" /> Categorias   
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                     {Loading  ?
                          <>
                            <div className="progress" style={{ height: "25px" }}>
                                    <div
                                      className="progress-bar bg-primary progress-bar-striped"
                                      role="progressbar"
                                      style={{ width: `${Progress}%` }}
                                      aria-valuenow={Progress}
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    >
                                      {Progress}% Completo
                                    </div>
                                </div><br />
                            </>
                            :
                            <>
                          {DadCont === "Emp" &&
                              <>
                          <div className="col-12">
                          <Butao 
                          style={"btn .btn-sm btn-primary"}
                          titulo={"Atualizar"}
                          onClick={()=>Editando()}
                          />  
                          </div><br />
                          <string style={{marginBottom:10, marginLeft:5}}>Id: {IdContRes} </string><br />
                          <string style={{marginBottom:10, marginLeft:5}}>Cliente: {ContasNome} </string><br />
                          <string style={{marginBottom:10, marginLeft:5}}>Tel: {ContasTel}</string><br /> 
                          </>
                           }
                            {MsgErro !== "" &&
                          <>
                        <div class="alert alert-danger alert-dismissible">
                  
                        <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                        {MsgErro}
                      </div>
                          </>
                          }
                          </>
                          }
                      
                    <strong>Digite o Nome da Categoria:</strong><br />
                    <div className="input_cadatro">
                              <Campo 
                                  type={"text"}
                                  placeholder= {"Digite a Categoria"}
                                  icon={"fas "}
                                  value={NomeEdit}
                                  onChange={e=>setNomeEdit(e.target.value)}
                                  mask={null}
                                />

                            </div> 
                    <br />
                  </address>
                </div>
                
              </div>
              <div className="row no-print">
             
              
              
              </div>
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}